"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardCustom = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const clsx_1 = __importDefault(require("clsx"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Card_1 = __importDefault(require("@material-ui/core/Card"));
const CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const card_styles_1 = require("../card-styles");
const dashboard_context_1 = require("../../dashboard-context");
const event_callback_hook_1 = require("../../../../utils/event-callback-hook");
function CardCustom({ navigate, actions, children, definitionId, }) {
    const intl = react_intl_1.useIntl();
    const classes = card_styles_1.useStyles();
    const { remove, classes: classesOverride } = react_1.useContext(dashboard_context_1.DashboardContext);
    const handleRemove = event_callback_hook_1.useEventCallback((event) => {
        remove(definitionId);
        event.stopPropagation();
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Card_1.default, { onClick: navigate, variant: "outlined", className: clsx_1.default(classes.card, classes.cardCustom, classesOverride === null || classesOverride === void 0 ? void 0 : classesOverride.card) },
            react_1.default.createElement(Box_1.default, { className: classes.cardRemove },
                react_1.default.createElement(IconButton_1.default, { size: "small", className: classes.cardRemoveButton, "aria-label": intl.formatMessage({
                        id: 'EAS_DASHBOARD_CARD_CUSTOM_REMOVE_BTN_ARIA',
                        defaultMessage: 'Odstranit',
                    }), onClick: handleRemove },
                    react_1.default.createElement(Close_1.default, { fontSize: 'small' }))),
            react_1.default.createElement(CardContent_1.default, { className: classes.cardCustomContent }, children)),
        react_1.default.createElement(Card_1.default, { className: classes.cardActions, variant: "outlined" }, actions)));
}
exports.CardCustom = CardCustom;
//# sourceMappingURL=card-custom.js.map